module.exports = __webpack_public_path__ + "static/media/team.ac9d214c.png";